import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationMoreHighlightedSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M7 12a3.25 3.25 0 11-6.5 0A3.25 3.25 0 017 12zM15.25 12a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0zM20.25 15.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z" />
      </g>
    </svg>
  )
);
SvgNavigationMoreHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationMoreHighlightedSmall;
